<script setup lang="ts"></script>

<template>
  <div class="modal-footer">
    <slot></slot>
  </div>
</template>
